import React from 'react';
import { CheckIcon, TargetIcon } from 'lucide-react';
import { SectionHeader } from '../SectionHeader';
import { CtaButton } from '../CtaButton';
import { volumes } from '../../data/volumes';
import { images } from '../../data/offer';
export function VolumesSection() {
  return <section className="w-full bg-white px-5 py-16 sm:py-24" data-id="element-325" data-mp="2rtq4ivsbn34z">
      <SectionHeader eyebrow="What’s inside Low Back Pain Assessment Blueprint™?" title="6 Practical Volumes for a More Organized Assessment Process" data-id="element-326" data-mp="2rs5cpdxe5yat" />

      <img src={images.mockup} alt="The six volumes of the Low Back Pain Assessment Blueprint" className="mx-auto mt-10 w-full max-w-2xl" data-id="element-327" data-mp="2iu3fl9gs3pst" />

      <div className="mx-auto mt-12 max-w-5xl space-y-8" data-id="element-328" data-mp="242kr0n9usmxu">
        {volumes.map(v => <article key={v.numeral} className="overflow-hidden rounded-3xl bg-paper ring-1 ring-slate-200" data-id="element-329" data-mp="291e6umcm4q16">
            <div className="flex items-center gap-4 bg-navy-900 px-6 py-5 sm:px-8" style={{
          borderLeft: `8px solid ${v.color}`
        }} data-id="element-330" data-mp="1v63f3hto0l11">
              <div className="shrink-0 text-center" data-id="element-331" data-mp="1fiqq19h8hjaa">
                <span className="block text-[11px] font-semibold uppercase tracking-[0.2em] text-slate-400" data-id="element-332" data-mp="1flcyrcfv24u3">Volume</span>
                <span className="block font-display text-4xl font-black leading-none" style={{
              color: v.color
            }} data-id="element-333" data-mp="1phfykbn8prdv">
                  {v.numeral}
                </span>
              </div>
              <h3 className="font-display text-2xl font-extrabold uppercase leading-tight text-white sm:text-3xl" data-id="element-334" data-mp="1kgikob99jji6">{v.title}</h3>
            </div>

            <div className="p-6 sm:p-8" data-id="element-335" data-mp="ruqrvohleqlo">
              <div className="space-y-3 text-lg leading-relaxed text-slate-700" data-id="element-336" data-mp="rrl36acvlqqh">
                {v.intro.map(p => <p key={p} data-id="element-337" data-mp="11rvhjyand478">{p}</p>)}
              </div>

              <p className="mt-6 font-display text-lg font-bold uppercase tracking-wide text-ink" data-id="element-338" data-mp="11psh0kbvbso9">Inside, you’ll explore:</p>
              <ul className="mt-3 grid gap-x-8 gap-y-2.5 md:grid-cols-2" data-id="element-339" data-mp="937pnjve7gkp">
                {v.items.map(item => <li key={item} className="flex items-start gap-2.5 text-base leading-snug text-slate-800" data-id="element-340" data-mp="yrvbk6twqrk4">
                    <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-brand-dark" strokeWidth={3} aria-hidden="true" data-id="element-341" data-mp="12s5f7cu895vt" />
                    {item}
                  </li>)}
              </ul>

              {v.note && <p className="mt-5 text-sm italic leading-relaxed text-slate-600" data-id="element-342" data-mp="1chf9mzcjn0n3">{v.note}</p>}

              <div className="mt-6 flex items-start gap-3 rounded-2xl bg-white p-4 ring-1 ring-slate-200" data-id="element-343" data-mp="ftss07k4pmtp">
                <TargetIcon className="mt-0.5 h-6 w-6 shrink-0 text-flame" aria-hidden="true" data-id="element-344" data-mp="juukm5jjj0mp" />
                <p className="text-base leading-relaxed text-slate-800" data-id="element-345" data-mp="ose8zy9yctsd">
                  <strong className="text-ink" data-id="element-346" data-mp="tsiphoav1oil">The goal:</strong> {v.goal}
                </p>
              </div>
            </div>
          </article>)}
      </div>

      <CtaButton label="Yes! I Want All 6 Volumes" sub="One-time payment of $27 · Instant access · 7-day guarantee" data-id="element-347" data-mp="257fgh3qlunsl" />
    </section>;
}